/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Already_SentInputs */

const en_issue_already_sent = /** @type {(inputs: Issue_Already_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`already sent with a sync of this linesheet: its product no longer changes`)
};

/**
* | output |
* | --- |
* | "already sent with a sync of this linesheet: its product no longer changes" |
*
* @param {Issue_Already_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_already_sent = /** @type {((inputs?: Issue_Already_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Already_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_already_sent(inputs)
});